import { z } from "zod";
import { Complexity, Priority, TaskType } from "@fathom/core";

// ── Extracted item (raw output from Claude) ────────────────

export const ExtractedItem = z.object({
  name: z.string(),
  category: z.string(),
  complexity: Complexity,
  priority: Priority,
  description: z.string(),
  rootCause: z.string().optional(),
  aiTasks: z.array(z.string()),
  acceptanceCriteria: z.string(),
});
export type ExtractedItem = z.infer<typeof ExtractedItem>;

// ── Velocity benchmark reference ───────────────────────────

export const VelocityBenchmarkRef = z.object({
  avgSessions: z.number(),
  avgDays: z.number(),
  avgCost: z.number(),
  dataPoints: z.number(),
});
export type VelocityBenchmarkRef = z.infer<typeof VelocityBenchmarkRef>;

// ── Enriched slice (after estimation + benchmarks) ─────────

export const EnrichedSlice = z.object({
  sliceId: z.string(),
  name: z.string(),
  category: z.string(),
  complexity: Complexity,
  priority: Priority,
  description: z.string(),
  rootCause: z.string().optional(),
  aiTasks: z.array(z.string()),
  acceptanceCriteria: z.string(),
  taskTypes: z.array(TaskType),
  recommendedModel: z.string(),
  estimatedTokens: z.number(),
  estimatedCost: z.number(),
  velocityBenchmark: VelocityBenchmarkRef.optional(),
  status: z.enum(["pending", "approved", "in_progress", "complete"]).default("pending"),
});
export type EnrichedSlice = z.infer<typeof EnrichedSlice>;

// ── Intake result (full pipeline output) ───────────────────

export const IntakeResult = z.object({
  project: z.string(),
  source: z.string(),
  rawInput: z.string(),
  slices: z.array(EnrichedSlice),
  totalEstimatedTokens: z.number(),
  totalEstimatedCost: z.number(),
  createdAt: z.string(),
});
export type IntakeResult = z.infer<typeof IntakeResult>;
